import { render, staticRenderFns } from "./remindDialogCommon.vue?vue&type=template&id=1f52bf5c&scoped=true&"
import script from "./remindDialogCommon.vue?vue&type=script&lang=js&"
export * from "./remindDialogCommon.vue?vue&type=script&lang=js&"
import style0 from "./remindDialogCommon.vue?vue&type=style&index=0&id=1f52bf5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f52bf5c",
  null
  
)

export default component.exports